import { useContext } from 'react';
import { CompanyContext, CompanyContextType } from '../providers/CompanyProvider';

/**
 * Hook to access company context
 * Must be used within CompanyProvider
 */
export function useCompany(): CompanyContextType {
  const context = useContext(CompanyContext);

  if (context === undefined) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }

  return context;
}
